<template>
  <div class="sz-py-4 sz-border-t-2 sz-border-gray-200">
    <div class="sz-flex sz-flex-wrap sz-text-lg popup--actions sz-justify-end">
      <div
        v-for="(answer, i) in answers"
        :key="`answer--${i}`"
        class="[&:not(:last-child)]:sz-mr-[16px]"
      >
        <div
          v-if="answer.type !== 'input'"
          class="sz-cursor-pointer sz-flex sz-items-center sz-gap-2 speech-bubble action-item speech-bubble-popup--client"
          @click="callFunctionAndEmit(answer.action, answer.actionPayload)"
        >
          <SvgIcon
            v-if="answer.icon"
            :name="answer.icon"
            class="sz-fill-none !sz-w-5 !sz-h-5"
          />
          <span>{{ answer.text }}</span>
        </div>
        <div v-else>
          <OnboardingActionInput
            :type="answer.inputType"
            :label="answer.label"
            :input-validator="answer.inputValidator"
            @send="send"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import OnboardingActionInput from "@/components/OnboardingActionInput.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import { onMounted, onBeforeUnmount } from "vue";

const props = defineProps<{ answers: any[] }>();
const emit = defineEmits(["updateStep"]);

const addMatomoEvent = () => {
  const currentUrl = window.top?.location?.href ?? window.location.href;
  (window.top as any)._paq?.push([
    "trackEvent",
    "Widget",
    "Click",
    "Click | Interact Chat",
    `CE - Chat Continue: ${currentUrl}`,
  ]);
};

const callFunctionAndEmit = (action: any, payload: any) => {
  emit("updateStep", payload);
  addMatomoEvent();
  if (!action) return;
};

const send = (value: any) => {
  emit("updateStep", value);
};

/**
 * Emit the function of the pressed number
 */
const numberPress = (event: KeyboardEvent) => {
  const key = parseInt(event.key);
  if (isNaN(key)) {
    return;
  }

  const answer = props.answers[key - 1];

  if (!answer || answer.type == "input") {
    return;
  }

  callFunctionAndEmit(answer.action, answer.actionPayload);
};

/**
 * Listen to keypress to allow to give the answers via number
 */
onMounted(() => {
  window.addEventListener("keypress", numberPress);
});

/**
 * Listen to keypress to allow to give the answers via number
 */
onBeforeUnmount(() => {
  window.removeEventListener("keypress", numberPress);
});
</script>
